exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".b-table-sticky-column{text-align:left!important}.motivation-table-th{display:block;padding:10px 0;color:#000}.td-light-gray{color:#000}.b-table tfoot th,.b-table tfoot th.b-table-sticky-column{background:#f5f5f5!important}.b-table tfoot th b{display:block;padding:12px 0;text-transform:uppercase}.bg-success{background-color:#0d6247!important}.progress-bar span{font-size:15px}", ""]);

// exports
